import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1091e210"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "systemMessageDialog_wrap"
};
const _hoisted_2 = {
  class: "notice_wrap"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { helpCenterWindow } from '@/assets/api/helpCenterMenu/helpCenter.js';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'systemMessageDialog',
  setup(__props, {
    expose
  }) {
    const myRouter = useRouter();
    // 弹窗显示、隐藏
    const dialogVisible = ref(false);
    // 系统消息列表
    const systemMessage = ref([]);
    // 打开弹窗
    // 打开弹窗前，先调用接口，如果返回的数据为空则，表示用户没有发布的消息，反之，打开弹窗
    const showDialog = async () => {
      var _data$data, _systemMessage$value;
      const data = await helpCenterWindow();
      systemMessage.value = (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.msg) || [];
      // systemMessage.value = [
      //   { id: 1, title: '这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案这是一段测试的文案' },
      //   { id: 2, title: '这是一段测试的文案' },
      //   { id: 3, title: '这是一段测试的文案' },
      //   { id: 4, title: '这是一段测试的文案' },
      // ]
      if (((_systemMessage$value = systemMessage.value) === null || _systemMessage$value === void 0 ? void 0 : _systemMessage$value.length) > 0) {
        dialogVisible.value = true;
      }
    };
    // 查看详情，跳转到消息通知页面
    const handleDetail = () => {
      myRouter.push({
        name: 'messageNotification',
        query: {
          messageNotificationType: 5
        }
      });
      dialogVisible.value = false;
    };
    // 暴露函数
    expose({
      showDialog
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        title: "发布通知",
        width: "600px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("我知道了")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleDetail
        }, {
          default: _withCtx(() => [_createTextVNode("查看详情")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemMessage.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "notice_item",
            key: item.id
          }, _toDisplayString(index + 1) + ". " + _toDisplayString(item.title), 1);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};